import React from 'react';

const LABELS = ['', 'Too weak', 'Weak', 'Good', 'Strong'];

/**
 * A rough 0–4 score for signup feedback only.
 *
 * This is a UX nicety, not a security control — the server's rules in
 * `auth.py` are what actually gate a password. Deliberately cheap: length plus
 * character variety, no dictionary, no zxcvbn dependency.
 */
export function scorePassword(password) {
  if (!password) return 0;

  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;

  const variety =
    (/[a-z]/.test(password) ? 1 : 0) +
    (/[A-Z]/.test(password) ? 1 : 0) +
    (/[0-9]/.test(password) ? 1 : 0) +
    (/[^A-Za-z0-9]/.test(password) ? 1 : 0);

  if (variety >= 2) score += 1;
  if (variety >= 3) score += 1;

  // A short password can't be "strong" no matter how varied it is.
  if (password.length < 8) return Math.min(score, 1);

  return Math.min(score, 4);
}

export default function PasswordStrength({ password }) {
  if (!password) return null;

  const score = scorePassword(password);

  return (
    <div className="mm-strength">
      <div className="mm-strength__track">
        {[1, 2, 3, 4].map((segment) => (
          <span
            key={segment}
            className={`mm-strength__seg ${
              segment <= score ? `mm-strength__seg--${score}` : ''
            }`}
          />
        ))}
      </div>
      {/* aria-live so the strength change is announced as you type. */}
      <div className="mm-strength__label" aria-live="polite">
        Password strength: {LABELS[score] || 'Too weak'}
      </div>
    </div>
  );
}
